import {Action, Module, Mutation, VuexModule} from 'vuex-module-decorators'
import {TabEnum} from "@/util/enums/TabEnum";
import infrastructure from "@/api/infrastructure";

@Module
export default class Infrastructure extends VuexModule {
    private _selectedBatchUuid = "";
    private _selectedProjectUuid = "";
    private _batchInfrastructureData: any = {};
    private _projectInfrastructureData: any = {};

    get batchIsSelected(): boolean {
        return this._selectedBatchUuid !== "";
    }

    get projectIsSelected(): boolean {
        return this._selectedProjectUuid !== "";
    }

    get selectedBatchUuid(): string {
        return this._selectedBatchUuid;
    }

    get selectedProjectUuid(): string {
        return this._selectedProjectUuid;
    }

    get infrastructureBatch(): Array<object> {
        if (this._batchInfrastructureData && this._batchInfrastructureData.items) {
            return this._batchInfrastructureData.items;
        }
        return [];
    }

    get infrastructureProject(): Array<object> {
        if (this._projectInfrastructureData && this._projectInfrastructureData.items) {
            return this._projectInfrastructureData.items;
        }
        return [];
    }

    get infrastructureBatchName(): string {
        if (this._batchInfrastructureData && this._batchInfrastructureData.name) {
            return this._batchInfrastructureData.name;
        }
        return "";
    }

    get infrastructureProjectName(): string {
        if (this._projectInfrastructureData && this._projectInfrastructureData.name) {
            return this._projectInfrastructureData.name;
        }
        return "";
    }

    @Mutation
    setSelectedBatchUuid(uuid: string): void {
        this._selectedBatchUuid = uuid;
    }

    @Mutation
    setSelectedProjectUuid(uuid: string): void {
        this._selectedProjectUuid = uuid;
    }

    @Mutation
    setProjectInfrastructureData(data: any): void {
        this._projectInfrastructureData = data;
    }

    @Mutation
    setBatchInfrastructureData(data: any): void {
        this._batchInfrastructureData = data;
    }

    @Mutation
    cleanProjectInfrastructureData(): void {
        this._projectInfrastructureData = {};
    }

    @Mutation
    cleanBatchInfrastructureData(): void {
        this._batchInfrastructureData = {};
    }

    @Action
    selectBatch(batchId: string, projectId: string | null = null) {
        this.context.dispatch('loadBatchData', batchId).then(() => {
            this.context.dispatch("changeTab", TabEnum.BatchInfrastructure);
            projectId && this.context.dispatch('loadProjectData', projectId).then();
        })

        this.context.commit('setSelectedBatchUuid', batchId);
    }

    @Action({commit: 'setSelectedProjectUuid'})
    selectProject(projectId: string) {
        this.context.dispatch('loadProjectData', projectId).then(() => {
            this.context.dispatch("changeTab", TabEnum.ProjectInfrastructure);
        })
        return projectId;
    }

    @Action
    loadProjectData(projectId: string) {
        return infrastructure.getProjectInfrastructure(projectId).then((response) => {
            this.context.commit("setProjectInfrastructureData", response.data);
        })
    }

    @Action
    loadBatchData(batchId: string) {
        return infrastructure.getBatchInfrastructure(batchId).then((response) => {
            this.context.commit("setBatchInfrastructureData", response.data);
        })
    }
}